import { Languages } from 'lucide-react';
import { usePortalCopy } from '../usePortalCopy';

export function LanguageControl({ onChange }: { onChange?: (language: 'tr' | 'en') => void }) {
  const { language, setLanguage, p } = usePortalCopy();
  const change = (next: 'tr' | 'en') => {
    if (next === language) return;
    if (onChange) onChange(next);
    else setLanguage(next);
  };
  return (
    <div role="group" className="inline-flex items-center gap-1 rounded-md border border-slate-700 bg-slate-900 p-1" aria-label={p('language')}>
      <Languages aria-hidden size={15} className="mx-1 text-slate-500" />
      {(['tr', 'en'] as const).map((item) => (
        <button key={item} type="button" lang={item} title={p(item)} onClick={() => change(item)} aria-pressed={language === item}
          className={`min-h-11 min-w-11 rounded px-2 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 ${language === item ? 'bg-slate-700 text-white' : 'text-slate-400 hover:text-white'}`}>
          {item.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
